import { MAIN_ROUTER } from 'routers/constants';
import {
  AppstoreOutlined,
  DashboardOutlined,
  ToolOutlined,
  WarningOutlined,
  InboxOutlined,
  EditOutlined,
  BarChartOutlined,
  SettingOutlined,
  ApiOutlined,
  BankOutlined,
  HddOutlined,
  UserOutlined,
  TeamOutlined,
  CarOutlined,
  // ThunderboltOutlined,
  AimOutlined,
  MailOutlined
} from '@ant-design/icons';

interface MenuItem {
  key: string;
  route?: string;
  icon?: any;
  role?: string;
  url?: string;
  childrens?: MenuItem[];
  type?: 'group';
}

const menuItem: MenuItem[] = [
  {
    key: 'dashboardGroup',
    type: 'group',
    role: '*',
    childrens: [
      // {
      //   key: 'dashboardHome',
      //   route: MAIN_ROUTER.DASHBOARD_HOME,
      //   icon: AppstoreOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardDevice',
      //   route: MAIN_ROUTER.DASHBOARD_DEVICE,
      //   icon: DashboardOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardBody',
      //   route: MAIN_ROUTER.DASHBOARD_BODY,
      //   icon: CarOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardVibration',
      //   route: MAIN_ROUTER.DASHBOARD_VIBRATION,
      //   icon: ThunderboltOutlined,
      //   role: '*'
      // },
      {
        key: 'dashboardLaser',
        route: MAIN_ROUTER.DASHBOARD_LASER,
        icon: AimOutlined,
        role: '*'
      },
      // {
      //   key: 'dashboardMaintenance',
      //   route: MAIN_ROUTER.DASHBOARD_MAINTENANCE,
      //   icon: ToolOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardIncident',
      //   route: MAIN_ROUTER.DASHBOARD_INCIDENT,
      //   icon: WarningOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardMaterial',
      //   route: MAIN_ROUTER.DASHBOARD_MATERIAL,
      //   icon: InboxOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardFeature',
      //   route: MAIN_ROUTER.DASHBOARD_FEATURE,
      //   icon: EditOutlined,
      //   role: '*'
      // },
      // {
      //   key: 'dashboardAnalytics',
      //   route: MAIN_ROUTER.DASHBOARD_ANALYTICS,
      //   icon: BarChartOutlined,
      //   role: '*'
      // }
    ]
  },
  {
    key: 'configGroup',
    type: 'group',
    role: '*',
    childrens: [
      {
        key: 'machineTypeManage',
        route: MAIN_ROUTER.CATEGORY_MACHINE_TYPE,
        icon: SettingOutlined,
        role: '*'
      },
      {
        key: 'connectionProtocolManage',
        route: MAIN_ROUTER.CATEGORY_PROTOCOL,
        icon: ApiOutlined,
        role: '*'
      },
      {
        key: 'unitManage',
        route: MAIN_ROUTER.CATEGORY_UNIT,
        icon: BankOutlined,
        role: '*'
      },
      {
        key: 'deviceManage',
        route: MAIN_ROUTER.CATEGORY_DEVICE,
        icon: HddOutlined,
        role: '*'
      },
      {
        key: 'mailConfigManage',
        route: MAIN_ROUTER.CATEGORY_MAIL_CONFIG,
        icon: MailOutlined,
        role: '*'
      }
    ]
  },
  // {
  //   key: 'systemManage',
  //   type: 'group',
  //   role: '*',
  //   childrens: [
  //     {
  //       key: 'userManage',
  //       route: MAIN_ROUTER.SYSTEM_USER,
  //       icon: UserOutlined,
  //       role: '*'
  //     },
  //     {
  //       key: 'roleManage',
  //       route: MAIN_ROUTER.SYSTEM_ROLE,
  //       icon: TeamOutlined,
  //       role: '*'
  //     }
  //   ]
  // }
];

export default menuItem;
